import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './state';
import * as api from 'src/api/home-display';
import { AppState } from 'src/store';
import { HomeDisplayCategory } from 'src/admin-entity/interface/home-display/home-display-category.interface';

export const searchHomeDisplayCategory = createAsyncThunk(
    `productGroupSearch/searchHomeDisplayCategory`,
    async (onlyDisplayContentsTypeProduct: boolean, { getState, rejectWithValue }) => {
        try {
            const { page, take, name, title, parentName, displayStatus } = (getState() as AppState)
                .homeDisplayCategorySearchReducer;
            const res = await api.searchHomeDisplayCategory(
                page,
                take,
                name,
                title,
                parentName,
                displayStatus,
                onlyDisplayContentsTypeProduct,
            );
            return res.data;
        } catch (err) {
            return rejectWithValue(err?.response?.data);
        }
    },
);

export const homeDisplayCategorySearchSlice = createSlice({
    name: 'homeDisplayCategorySearchSlice',
    initialState,
    reducers: {
        initHomeDisplayCategorySearch: () => {
            return initialState;
        },
        setTake: (state, action: PayloadAction<number>) => {
            state.take = action.payload;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        onChangeParentName: (state, action: PayloadAction<string>) => {
            state.parentName = action.payload;
        },
        onChangeName: (state, action: PayloadAction<string>) => {
            state.name = action.payload;
        },
        onChangeTitle: (state, action: PayloadAction<string>) => {
            state.title = action.payload;
        },
        onChangedisplayStatus: (state, action: PayloadAction<string>) => {
            state.displayStatus = action.payload;
        },
        addSingleModeSearchedHomeDisplay: (state, action: PayloadAction<HomeDisplayCategory>) => {
            state.selectedSearchedHomeDisplay = [action.payload];
        },
        addSearchedHomeDisplay: (state, action: PayloadAction<HomeDisplayCategory>) => {
            state.selectedSearchedHomeDisplay.push(action.payload);
        },
        addSearchedHomeDisplayList: (state, action: PayloadAction<HomeDisplayCategory[]>) => {
            state.selectedSearchedHomeDisplay = action.payload;
        },
        removeSearchedHomeDisplay: (state, action: PayloadAction<HomeDisplayCategory>) => {
            state.selectedSearchedHomeDisplay = state.selectedSearchedHomeDisplay.filter(
                item => item.id !== action.payload.id,
            );
        },
    },
    extraReducers: builder => {
        builder.addCase(searchHomeDisplayCategory.fulfilled, (state, { payload }) => {
            state.searchResult = payload;
        });
    },
});

export default homeDisplayCategorySearchSlice.reducer;
export const {
    initHomeDisplayCategorySearch,
    onChangeParentName,
    onChangeName,
    onChangeTitle,
    onChangedisplayStatus,
    setPage,
    setTake,
    addSingleModeSearchedHomeDisplay,
    addSearchedHomeDisplay,
    addSearchedHomeDisplayList,
    removeSearchedHomeDisplay,
} = homeDisplayCategorySearchSlice.actions;
